import { DestroyRef, inject, Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoginRegisterWrapperComponent } from './login-register-wrapper.component';
import { takeUntil } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
 providedIn: 'root',
})
export class LoginRegisterUiService {
 constructor(private router: Router, private dialog: MatDialog, private route: ActivatedRoute) {}
 destroyRef = inject(DestroyRef);

 showMyModal() {
  const dialogRef = this.dialog.open(LoginRegisterWrapperComponent, {
   panelClass: [
    'login-modal',
    'w-screen',
    'lg:w-[800px]',
    'h-screen',
    'lg:h-3/5',
    '!max-w-full',
    'lg:min-h-[500px]',
   ],
   data: {},
   autoFocus: false,
  });
  // Handle the result or any other actions as needed
  dialogRef
   .afterClosed()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((result) => {});
 }
 monitorRouteChanges() {
  this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((param: any) => {
   if (param.showModal) {
    this.showMyModal();
   }
  });
 }
}
